module.exports = __webpack_public_path__ + "79afb5e53a1121caba083872a6631ab6.svg";